import * as z from "zod";

export const saveWithdrawalsOnboardingSettings = {
  name: "saveWithdrawalsOnboardingSettings" as const,
  input: z.object({
    chargeAmount: z.string().optional(),
    chargeShipping: z.boolean().optional(),
    chargeType: z.enum(["actual", "flat"]).optional(),
    enableThirdPartyFulfillmentCancellationEmail: z.boolean().optional(),
    merchantNotificationEmails: z.array(z.string()).optional(),
    returnAddress: z.string().optional(),
    thirdPartyFulfillmentCancellationEmails: z.array(z.string()).optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
